import classNames from 'classnames';
import { h6TextStyle, p6TextStyle } from 'lib/common/theme/typography';
import { ImageAsset } from 'lib/shop/types';
import Image from 'next/image';
import { CSSProperties, ReactNode } from 'react';

interface Props<T> {
  item: T;
  title: string;
  subtitle?: string | ReactNode;
  imageUrl?: string;
  logoAsset?: ImageAsset;
  // isSuperGreen: boolean;
  containerStyle?: string;
  style?: string;
  containerCSSStyle?: CSSProperties;
  onTappedItem?: (item: T) => void;
}
export default function GenericCarouselItem<T>({
  item,
  title,
  subtitle,
  imageUrl,
  logoAsset,
  // isSuperGreen,
  containerStyle,
  style,
  containerCSSStyle,
  onTappedItem,
}: Props<T>) {
  return (
    <div
      className={classNames(
        containerStyle ? containerStyle : 'mr-4 w-40 cursor-pointer',
      )}
      style={containerCSSStyle}
      onClick={() => onTappedItem?.(item)}
    >
      <div
        className={classNames(
          'border-black/05 relative h-[180px] max-w-full overflow-hidden rounded-xl border bg-white',
          style ? style : 'w-40',
        )}
      >
        {logoAsset?.url && (
          <div className="absolute top-2 left-2 z-10 h-10 w-10 overflow-hidden rounded-full border border-[#C9C9C9] bg-white">
            <Image alt="Logo" src={logoAsset.url} layout="fill" />
          </div>
        )}
        {imageUrl ? (
          <Image
            alt="Image"
            className="flex-1"
            src={imageUrl}
            layout="fill"
            objectFit="cover"
          />
        ) : null}
      </div>
      <div className="mt-2 flex-row items-center">
        <h3
          className={classNames(
            h6TextStyle,
            'flex-1 overflow-hidden text-ellipsis',
          )}
        >
          {title}
        </h3>
        {/* {isSuperGreen && (
          <Image
            alt="Supergreen"
            className="w-18px h-18px"
            src={require("../../../../assets/icons/merchant/medal_small.png")}
          />
        )} */}
      </div>
      <div
        className={classNames(
          p6TextStyle,
          'mt-0.5 overflow-hidden text-gray-600 line-clamp-2',
        )}
      >
        {subtitle ?? ' '}
      </div>
    </div>
  );
}
